/*
 * Keep the cart drawer in sync with changes made on other surfaces (mainly the full
 * cart page). The drawer renders its contents into a <template> and only reacts to its
 * own item changes, so quantity edits on /cart leave it stale until a full reload.
 *
 * On every cartUpdate where the drawer is NOT the active surface, silently re-fetch the
 * rendered cart-drawer section and refresh the drawer's template (used on the next open)
 * plus the live container if it was already populated. No visual change, no auto-open.
 */
(function () {
  if (window.__waldCartDrawerSync) return;
  window.__waldCartDrawerSync = true;

  var pending = false;

  function drawerSectionUrl() {
    var base = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    return base + '?section_id=cart-drawer';
  }

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    // Only while the drawer is closed — when open it updates itself. Check `active`
    // only: the `animate` class lingers after the first open (close() never removes it)
    // and must not permanently block the refresh.
    if (drawer.classList.contains('active')) return;

    fetch(drawerSectionUrl(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var nextTemplate = parsed.querySelector('template[data-cart-drawer-content-template]');
        if (!nextTemplate) return;

        // Always refresh the template (it's not the live UI) so the next open is correct.
        var tmpl = drawer.querySelector('template[data-cart-drawer-content-template]');
        if (tmpl) tmpl.innerHTML = nextTemplate.innerHTML;

        // Re-check AFTER the async fetch: if the drawer was opened while it was in flight,
        // leave its live content alone (don't wipe it out from under the user). Otherwise
        // drop the stale container so the next open rebuilds from the fresh template.
        if (!drawer.classList.contains('active')) {
          var container = drawer.querySelector('[data-cart-drawer-content-container]');
          if (container) {
            container.innerHTML = '';
            container.setAttribute('hidden', '');
          }
        }
      })
      .catch(function () {});
  }

  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      refreshDrawer();
    }, 60);
  }

  function init() {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
